import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadStepCompoundBuyCarConsent,
  CarleadTopBlueCarHCSliderMap,
  DEFAULT_SLIDER_SETTINGS,
  MatomoHelmet,
} from '@wkda/marketing-components';
import { ConversationalLeadTitle } from '@wkda/conversational-carlead';

function CarleadCreation() {
  return (
    <>
      <MatomoHelmet />
      <BaseConversationalLeadPage
        content={CarleadTopBlueCarHCSliderMap}
        manualForm={<CarleadStepCompoundBuyCarConsent showHeadline={false} />}
        showTrustPilot={true}
        howItWorksShowCta={true}
        happyCustomerSettingsOverrides={DEFAULT_SLIDER_SETTINGS}
        blue={true}
        titleComponent={ConversationalLeadTitle}
        modeToggleClassName={null}
      />
    </>
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
